// src/pages/jury/ApplicationsPage.tsx
import React from 'react';
import JuryApplicationList from '../../components/jury/JuryApplicationList';

const JuryApplicationsPage: React.FC = () => {
  return <JuryApplicationList />;
};

export default JuryApplicationsPage;